// removed by extract-text-webpack-plugin
module.exports = {"paging-bar":"PaginationBar__paging-bar___1ZQBT","paging-content":"PaginationBar__paging-content___113Ly"};